<div class="flex flex-grow container py-8" *transloco="let t; prefix: 'property-listing.complete'">
    <div class="flex flex-grow container py-8">
        <div class="flex-grow flex lg:flex-row flex-col lg:items-start items-center justify-center">
            <div class=" flex flex-1 justify-center">
                <div class="flex flex-col rfs:gap-8">
                    <div class="flex flex-col gap-2">
                        <h1 class="text-black text-[2.5rem] leading-[48px]" [innerHTML]="t('header')"></h1>
                        <p class="max-w-[380px] text-[26px] text-gray-900" [innerHTML]="t('description')"></p>
                        <p class="max-w-[380px] text-gray-900" [innerHTML]="t('infoText')"></p>
                    </div>
                    <ng-container>
                        <div>
                            <div class="flex flex-col w-full gap-6 md:flex-row">
                                <button (click)="goToListing()" role="button"
                                    class="btn-primary">{{t('anchors.goToListing')}}</button>
                            </div>

                        </div>
                    </ng-container>
                </div>
            </div>
            <img src="../../../../assets/img/listing-complete.png" alt="">
        </div>
    </div>
</div>
